import { assertNever } from "@sa-nu/shared-utils/misc";

import type { AccommodationReservationProvider } from "../../__generated__/gql/graphql";
import { LEGAL_DOCUMENTS } from "../../constants";

export function useAccommodationTermsLink(
  provider: AccommodationReservationProvider | null | undefined,
): {
  title: string;
  url: string;
} | null {
  if (!provider) {
    return null;
  }

  switch (provider.__typename) {
    case "BusinessPlanAccommodationReservationProvider":
      return LEGAL_DOCUMENTS.accommodationTermsForBusiness;
    case "TrialPlanAccommodationReservationProvider":
      return LEGAL_DOCUMENTS.accommodationTermsForTrial;
    case "CoOwnersPlanAccommodationReservationProvider":
    case "FullOwnerPlanAccommodationReservationProvider":
    case "OneMoreCabinAccommodationReservationProvider":
    case "OnlineTravelAgentAccommodationReservationProvider":
    case "SanuIncAccommodationReservationProvider":
    case "StandardPlanAccommodationReservationProvider":
    case "StaffPlanAccommodationReservationProvider":
    case "StayTicketAccommodationReservationProvider":
    case "StayDirectAccommodationReservationProvider":
      return LEGAL_DOCUMENTS.accommodationTerms;
    default: {
      assertNever(provider);
    }
  }
}
